<div
  class="fixed inset-0 z-50 flex items-center justify-center p-3 md:p-5 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="onClose()">
  <div
    class="relative w-full max-w-[92vw] xl:max-w-[1280px] h-[92vh] bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 overflow-hidden flex flex-col animate-fade-in-up"
    (click)="$event.stopPropagation()">

    <div *ngIf="isSaving() || isLoading()"
      class="absolute inset-0 bg-white/80 dark:bg-slate-900/80 z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <!-- Header -->
    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4 bg-white dark:bg-slate-900">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">{{ isEdit ? 'edit' : 'group_add' }}</span>
          {{ isEdit ? 'แก้ไข Stamp Group' : 'เพิ่ม Stamp Group' }}
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          ลาน:
          <span class="font-semibold text-amber-600 dark:text-amber-400">{{ siteName || detail.siteName || '—' }}</span>
        </p>
      </div>
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
        <span class="material-icons">close</span>
      </button>
    </div>

    <!-- Body -->
    <div class="flex-1 min-h-0 flex flex-col lg:flex-row bg-white dark:bg-slate-900" *ngIf="!isLoading(); else loadingTpl">

      <!-- LEFT -->
      <div class="flex-1 min-w-0 flex flex-col border-b lg:border-b-0 lg:border-r border-slate-100 dark:border-slate-800">
        <div class="px-6 md:px-8 pt-4 flex flex-wrap gap-2 border-b border-slate-100 dark:border-slate-800 shrink-0 bg-white dark:bg-slate-900">
          <button type="button" *ngFor="let t of tabs" (click)="setTab(t.key)"
            class="relative px-4 py-3 text-sm font-bold transition-colors border-none bg-transparent"
            [ngClass]="activeTab === t.key
              ? 'text-amber-600 dark:text-amber-400 cursor-pointer'
              : (t.key !== 'general' && !isEdit)
                ? 'text-slate-300 dark:text-slate-600 cursor-not-allowed'
                : 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 cursor-pointer'"
            [disabled]="t.key !== 'general' && !isEdit">
            <span class="flex items-center gap-1">
              {{ t.label }}
              <span *ngIf="t.key !== 'general' && !isEdit" class="material-icons text-[14px]">lock</span>
            </span>
            <span *ngIf="activeTab === t.key"
              class="absolute left-2 right-2 bottom-0 h-0.5 rounded-full bg-amber-400"></span>
          </button>
        </div>

        <div class="flex-1 overflow-y-auto custom-scrollbar px-6 md:px-8 py-6 bg-white dark:bg-slate-900">

          <!-- General -->
          <ng-container *ngIf="activeTab === 'general'">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div class="md:col-span-2">
                <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
                  ชื่อกลุ่ม <span class="text-rose-500">*</span>
                </label>
                <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
                  <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">badge</span>
                  <input type="text" [(ngModel)]="detail.name" [disabled]="isSaving()" placeholder="ชื่อกลุ่ม"
                    class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none placeholder:text-slate-400 disabled:opacity-50">
                </div>
              </div>

              <div>
                <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">ประเภทค่าใช้จ่าย</label>
                <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
                  <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">payments</span>
                  <select [(ngModel)]="detail.costType" (ngModelChange)="onCostTypeChange()" [disabled]="isSaving()"
                    class="w-full h-full pl-10 pr-8 bg-transparent border-none text-sm font-medium focus:outline-none appearance-none cursor-pointer disabled:opacity-50">
                    <option value="free">ฟรี</option>
                    <option value="billable">เรียกเก็บลูกค้าตามหลัง</option>
                  </select>
                  <span class="absolute right-3 material-icons text-slate-400 text-lg pointer-events-none">expand_more</span>
                </div>
              </div>

              <div *ngIf="isBillable">
                <app-pss-searchable-picker
                  label="ลูกค้า (เรียกเก็บตามหลัง)"
                  icon="storefront"
                  placeholder="ค้นหาลูกค้า..."
                  [required]="true"
                  [disabled]="isSaving()"
                  [selectedId]="detail.cpCustomerId"
                  [displayText]="detail.cpCustomerName || ''"
                  [options]="customerPickerOptions()"
                  [total]="customerPickerTotal()"
                  [previewSize]="20"
                  [loading]="customerPickerLoading()"
                  (opened)="onCustomerOpened()"
                  (searchChange)="onCustomerSearch($event)"
                  (optionSelected)="onCustomerSelected($event)"
                  (cleared)="onCustomerCleared()">
                </app-pss-searchable-picker>
              </div>

              <div class="md:col-span-2 flex flex-wrap gap-3">
                <label class="inline-flex items-center gap-3 px-4 h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 cursor-pointer select-none hover:border-amber-300 transition-colors">
                  <span class="relative inline-flex h-5 w-5 items-center justify-center">
                    <input type="checkbox" class="peer sr-only" [(ngModel)]="detail.active" [disabled]="isSaving()">
                    <span class="absolute inset-0 rounded-md border-2 border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 transition-all peer-checked:border-amber-400 peer-checked:bg-amber-400"></span>
                    <span class="material-icons relative z-[1] text-white text-[14px] leading-none opacity-0 peer-checked:opacity-100 pointer-events-none">check</span>
                  </span>
                  <span class="text-sm font-bold text-slate-700 dark:text-slate-200">เปิดใช้กลุ่ม</span>
                </label>
                <label class="inline-flex items-center gap-3 px-4 h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 cursor-pointer select-none hover:border-amber-300 transition-colors">
                  <span class="relative inline-flex h-5 w-5 items-center justify-center">
                    <input type="checkbox" class="peer sr-only" [(ngModel)]="detail.hasLimit" [disabled]="isSaving()">
                    <span class="absolute inset-0 rounded-md border-2 border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 transition-all peer-checked:border-amber-400 peer-checked:bg-amber-400"></span>
                    <span class="material-icons relative z-[1] text-white text-[14px] leading-none opacity-0 peer-checked:opacity-100 pointer-events-none">check</span>
                  </span>
                  <span class="text-sm font-bold text-slate-700 dark:text-slate-200">มีโควต้ากลุ่ม</span>
                </label>
              </div>

              <div *ngIf="detail.hasLimit">
                <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">ประเภทโควต้า</label>
                <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
                  <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">category</span>
                  <select [(ngModel)]="detail.limitType" [disabled]="isSaving()"
                    class="w-full h-full pl-10 pr-8 bg-transparent border-none text-sm font-medium focus:outline-none appearance-none cursor-pointer disabled:opacity-50">
                    <option value="month">ต่อเดือน</option>
                    <option value="total">จำนวนครั้งรวม</option>
                  </select>
                  <span class="absolute right-3 material-icons text-slate-400 text-lg pointer-events-none">expand_more</span>
                </div>
              </div>

              <div *ngIf="detail.hasLimit">
                <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">จำนวนโควต้า</label>
                <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
                  <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">confirmation_number</span>
                  <input type="number" [(ngModel)]="detail.limitQty" [disabled]="isSaving()"
                    class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none disabled:opacity-50">
                </div>
              </div>

              <div class="md:col-span-2">
                <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">หมายเหตุ</label>
                <textarea [(ngModel)]="detail.remark" rows="3" [disabled]="isSaving()" placeholder="หมายเหตุเพิ่มเติม"
                  class="w-full px-4 py-3 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30 resize-none disabled:opacity-50 placeholder:text-slate-400"></textarea>
              </div>
            </div>

            <div class="mt-6 flex justify-between items-center gap-3">
              <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
                class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 font-bold inline-flex items-center gap-2 disabled:opacity-50 cursor-pointer">
                <span class="material-icons text-[18px]">history</span>
                ดูประวัติ
              </button>
              <button type="button" (click)="onSaveGeneral()" [disabled]="isSaving()"
                class="ml-auto px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-amber-900/30 transition-all disabled:opacity-50 flex items-center gap-2">
                <span class="material-icons text-[18px]">save</span>
                {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึกทั่วไป' }}
              </button>
            </div>
          </ng-container>

          <!-- Lines -->
          <ng-container *ngIf="activeTab === 'lines'">
            <div class="mb-5 p-4 rounded-2xl border border-amber-200/70 dark:border-amber-500/30 bg-amber-50/40 dark:bg-amber-900/10 space-y-3">
              <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
                เลือกส่วนลดที่ต้องการเพิ่ม (เลือกได้หลายรายการ)
              </label>
              <div class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[42px] mb-3">
                <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">search</span>
                <input type="text" [(ngModel)]="rateSearchText$" [disabled]="isSaving()" placeholder="ค้นหา rate id / ชื่อ..."
                  class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none placeholder:text-slate-400 disabled:opacity-50">
              </div>
              <div class="max-h-[260px] overflow-y-auto custom-scrollbar rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
                <div *ngIf="availableRatesForCheckbox.length > 0"
                  class="sticky top-0 z-10 px-4 py-2.5 border-b border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-800 flex items-center gap-3">
                  <label class="inline-flex items-center gap-2 cursor-pointer select-none">
                    <span class="relative inline-flex h-5 w-5 items-center justify-center">
                      <input type="checkbox" class="peer sr-only" [checked]="allAvailableSelected" (change)="selectAllAvailableRates()" [disabled]="isSaving()">
                      <span class="absolute inset-0 rounded-md border-2 border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 transition-all peer-checked:border-amber-400 peer-checked:bg-amber-400"></span>
                      <span class="material-icons relative z-[1] text-white text-[14px] leading-none opacity-0 peer-checked:opacity-100 pointer-events-none">check</span>
                    </span>
                    <span class="text-xs font-bold text-slate-500 dark:text-slate-400">เลือกทั้งหมด ({{ availableRatesForCheckbox.length }})</span>
                  </label>
                  <span *ngIf="selectedRateIds.size > 0" class="ml-auto text-xs font-bold text-amber-600 dark:text-amber-400">
                    เลือกแล้ว {{ selectedRateIds.size }} รายการ
                  </span>
                </div>
                <div *ngFor="let rate of availableRatesForCheckbox"
                  class="px-4 py-2.5 flex items-center gap-3 hover:bg-amber-50/40 dark:hover:bg-slate-800/60 transition-colors border-b border-slate-50 dark:border-slate-800 last:border-b-0">
                  <label class="inline-flex items-center gap-3 cursor-pointer select-none flex-1 min-w-0">
                    <span class="relative inline-flex h-5 w-5 items-center justify-center shrink-0">
                      <input type="checkbox" class="peer sr-only" [checked]="selectedRateIds.has(rate.id)" (change)="toggleRateCheckbox(rate.id)" [disabled]="isSaving()">
                      <span class="absolute inset-0 rounded-md border-2 border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 transition-all peer-checked:border-amber-400 peer-checked:bg-amber-400"></span>
                      <span class="material-icons relative z-[1] text-white text-[14px] leading-none opacity-0 peer-checked:opacity-100 pointer-events-none">check</span>
                    </span>
                    <span class="text-sm font-semibold text-slate-700 dark:text-slate-200 truncate">
                      <span class="font-mono text-xs text-sky-600 dark:text-sky-400 mr-1.5">{{ rate.rateId }}</span>{{ rate.name }}
                    </span>
                  </label>
                </div>
                <div *ngIf="availableRatesForCheckbox.length === 0" class="px-4 py-10 text-center text-sm text-slate-400">
                  <span class="material-icons text-2xl mb-2 block opacity-40">local_offer</span>
                  {{ rateOptions.length === 0 ? 'ไม่พบส่วนลด' : 'ส่วนลดทั้งหมดอยู่ในกลุ่มแล้ว' }}
                </div>
              </div>
              <button type="button" (click)="onSaveLinesBulk()" [disabled]="isSaving() || selectedRateIds.size === 0"
                class="w-full h-[46px] rounded-xl bg-amber-400 hover:bg-amber-500 disabled:opacity-50 text-white text-sm font-bold flex items-center justify-center gap-2 transition-all">
                <span class="material-icons text-[18px]">add</span>
                เพิ่มส่วนลดที่เลือก ({{ selectedRateIds.size }}) เข้ากลุ่ม
              </button>
            </div>

            <div class="rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden">
              <table class="w-full text-sm text-left border-collapse">
                <thead class="bg-slate-50 dark:bg-slate-800 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                  <tr>
                    <th class="px-4 py-3">Rate</th>
                    <th class="px-4 py-3">ชื่อส่วนลด</th>
                    <th class="px-4 py-3 text-center">สถานะ</th>
                    <th class="px-4 py-3 text-center">Seq</th>
                    <th class="px-4 py-3 text-center w-[110px]">จัดการ</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-slate-100 dark:divide-slate-800">
                  <tr *ngFor="let line of detail.lines"
                    class="hover:bg-amber-50/40 dark:hover:bg-slate-800/60 transition-colors"
                    [ngClass]="{ 'opacity-60': !line.active }">
                    <td class="px-4 py-3 font-mono text-xs font-bold text-sky-600 dark:text-sky-400">{{ line.rateId }}</td>
                    <td class="px-4 py-3 font-semibold text-slate-700 dark:text-slate-200">{{ line.rateName }}</td>
                    <td class="px-4 py-3 text-center">
                      <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold border"
                        [ngClass]="line.active
                          ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800'
                          : 'bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 border-slate-200 dark:border-slate-700'">
                        {{ line.active ? 'เปิดใช้' : 'ปิดใช้' }}
                      </span>
                    </td>
                    <td class="px-4 py-3 text-center text-slate-500">{{ line.sequence ?? '—' }}</td>
                    <td class="px-4 py-3 text-center">
                      <button *ngIf="line.active" type="button" (click)="askDeactivateLine(line)"
                        class="px-3 py-1.5 rounded-lg text-xs font-bold text-slate-600 dark:text-slate-300 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors">
                        ปิดใช้
                      </button>
                      <button *ngIf="!line.active" type="button" (click)="askActivateLine(line)"
                        class="px-3 py-1.5 rounded-lg text-xs font-bold text-emerald-700 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/20 hover:bg-emerald-100 transition-colors">
                        เปิดใช้
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="detail.lines.length === 0">
                    <td colspan="5" class="px-4 py-12 text-center">
                      <div class="flex flex-col items-center text-slate-400">
                        <span class="material-icons text-3xl mb-2">local_offer</span>
                        <p class="font-bold text-slate-600 dark:text-slate-300">ยังไม่มีส่วนลดในกลุ่ม</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>

          <!-- Members -->
          <ng-container *ngIf="activeTab === 'members'">
            <div class="mb-5 flex flex-wrap items-center justify-between gap-3">
              <p class="text-sm text-slate-500 dark:text-slate-400 font-medium">เลือกลูกค้าพนักงาน (res_users) เพื่อเพิ่มเข้ากลุ่ม</p>
              <button type="button" (click)="openUserPicker()" [disabled]="isSaving()"
                class="px-5 h-[46px] rounded-xl bg-amber-400 hover:bg-amber-500 disabled:opacity-50 text-white text-sm font-bold flex items-center gap-2 transition-all">
                <span class="material-icons text-[18px]">person_search</span> ค้นหา / เลือก User
              </button>
            </div>

            <div class="rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden">
              <table class="w-full text-sm text-left border-collapse">
                <thead class="bg-slate-50 dark:bg-slate-800 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
                  <tr>
                    <th class="px-4 py-3">Login</th>
                    <th *ngIf="groupHasQuota" class="px-4 py-3 text-center">Used</th>
                    <th *ngIf="groupHasQuota" class="px-4 py-3 text-center">Month</th>
                    <th class="px-4 py-3 text-center">จัดการ</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-slate-100 dark:divide-slate-800">
                  <tr *ngFor="let m of detail.members"
                    class="hover:bg-amber-50/40 dark:hover:bg-slate-800/60 transition-colors">
                    <td class="px-4 py-3 font-semibold text-slate-700 dark:text-slate-200">{{ m.login }}</td>
                    <td *ngIf="groupHasQuota" class="px-4 py-3 text-center font-bold tabular-nums text-slate-700 dark:text-slate-200">{{ m.usedQty }}</td>
                    <td *ngIf="groupHasQuota" class="px-4 py-3 text-center font-bold tabular-nums text-slate-700 dark:text-slate-200">{{ m.usedMonthQty }}</td>
                    <td class="px-4 py-3 text-center">
                      <div class="inline-flex items-center gap-2">
                        <button *ngIf="groupHasQuota" type="button" (click)="resetMemberQuota(m)"
                          class="px-3 py-1.5 rounded-lg text-xs font-bold text-amber-700 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 hover:bg-amber-100 transition-colors">
                          Reset quota
                        </button>
                        <button type="button" (click)="askDeactivateMember(m)"
                          class="px-3 py-1.5 rounded-lg text-xs font-bold text-rose-600 dark:text-rose-400 bg-rose-50 dark:bg-rose-900/20 hover:bg-rose-100 transition-colors">
                          ยกเลิกสมาชิก
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="detail.members.length === 0">
                    <td [attr.colspan]="groupHasQuota ? 4 : 2" class="px-4 py-12 text-center">
                      <div class="flex flex-col items-center text-slate-400">
                        <span class="material-icons text-3xl mb-2">group_off</span>
                        <p class="font-bold text-slate-600 dark:text-slate-300">ยังไม่มีสมาชิก</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- RIGHT: Logs -->
      <aside class="w-full lg:w-[340px] xl:w-[380px] shrink-0 flex flex-col bg-slate-50 dark:bg-slate-950/50 min-h-[220px] lg:min-h-0 border-t lg:border-t-0 border-slate-100 dark:border-slate-800">
        <div class="px-5 py-4 border-b border-slate-100 dark:border-slate-800 shrink-0 flex items-center justify-between bg-slate-50 dark:bg-slate-950/50">
          <div class="flex items-center gap-2">
            <span class="material-icons text-amber-500 text-[18px]">history</span>
            <h3 class="text-sm font-bold text-slate-800 dark:text-slate-100">Activity Log</h3>
          </div>
          <span class="text-[11px] font-bold text-slate-400" *ngIf="detail.id">{{ logsTotal }} รายการ</span>
        </div>
        <div class="flex-1 overflow-y-auto custom-scrollbar p-4 space-y-2">
          <ng-container *ngIf="detail.id; else noGroupYet">
            <div *ngFor="let log of logs"
              class="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-3">
              <div class="flex items-start justify-between gap-2 mb-1">
                <span class="px-2 py-0.5 rounded-md bg-amber-50 dark:bg-amber-900/20 text-[11px] font-bold text-amber-700 dark:text-amber-400">
                  {{ log.action }}
                </span>
                <span class="text-[10px] text-slate-400 tabular-nums whitespace-nowrap">
                  {{ log.createDate | date:'dd/MM/yy HH:mm':'':'en-GB' }}
                </span>
              </div>
              <div class="text-xs font-semibold text-slate-600 dark:text-slate-300">
                {{ log.actorLogin || '—' }}
                <span *ngIf="log.targetLogin" class="text-slate-400 font-medium"> → {{ log.targetLogin }}</span>
              </div>
              <p *ngIf="log.remark" class="text-[11px] text-slate-400 mt-1 leading-snug">{{ log.remark }}</p>
            </div>
            <div *ngIf="logs.length === 0" class="py-12 text-center text-sm text-slate-400">
              <span class="material-icons text-3xl mb-2 block opacity-40">inbox</span>
              ยังไม่มี log
            </div>
          </ng-container>
          <ng-template #noGroupYet>
            <div class="py-12 px-2 text-center text-sm text-slate-400">
              <span class="material-icons text-3xl mb-2 block opacity-40">info</span>
              บันทึกกลุ่มก่อน เพื่อดูประวัติการเปลี่ยนแปลง
            </div>
          </ng-template>
        </div>
      </aside>
    </div>

    <ng-template #loadingTpl>
      <div class="p-16 flex flex-col items-center justify-center text-slate-400 flex-1 bg-white dark:bg-slate-900">
        <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin mb-3"></div>
        <p class="text-sm font-medium">กำลังโหลด...</p>
      </div>
    </ng-template>
  </div>
</div>

<!-- Nested: pick res_users forTable -->
<div *ngIf="showUserPicker"
  class="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="closeUserPicker()">
  <div class="w-full max-w-3xl max-h-[85vh] bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 flex flex-col overflow-hidden animate-fade-in-up"
    (click)="$event.stopPropagation()">
    <div class="flex-none px-6 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4 bg-white dark:bg-slate-900">
      <div>
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">person_search</span>
          เลือก User
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          เลือกได้หลายคน · ไม่ปิดอัตโนมัติ · ไม่แสดงสมาชิกที่มีอยู่แล้ว
        </p>
      </div>
      <button type="button" (click)="closeUserPicker()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="px-6 py-3 border-b border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row gap-3 bg-white dark:bg-slate-900">
      <div class="relative flex-1 flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
        <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">search</span>
        <input type="text" [ngModel]="userPickerSearch" (ngModelChange)="onUserPickerSearchInput($event)"
          placeholder="ค้นหา login / ชื่อ role..."
          class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none placeholder:text-slate-400">
      </div>
      <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 h-[46px] min-w-[150px]">
        <select [ngModel]="userPickerPageSize" (ngModelChange)="onUserPageSizeChange(+$event)"
          class="w-full h-full px-3 pr-8 bg-transparent border-none text-sm font-semibold text-slate-600 dark:text-slate-300 appearance-none cursor-pointer focus:outline-none">
          <option *ngFor="let size of userPageSizeOptions" [ngValue]="size">{{ size }} แถว/หน้า</option>
        </select>
        <span class="absolute right-2 material-icons text-slate-400 text-lg pointer-events-none">expand_more</span>
      </div>
    </div>

    <div class="flex-1 overflow-y-auto custom-scrollbar relative min-h-[280px] bg-white dark:bg-slate-900">
      <div *ngIf="userPickerLoading()"
        class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 z-10 flex items-center justify-center">
        <div class="w-8 h-8 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
      </div>
      <table class="w-full text-sm text-left border-collapse">
        <thead class="sticky top-0 z-10 bg-slate-50 dark:bg-slate-800 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
          <tr>
            <th class="px-5 py-3">Login</th>
            <th class="px-5 py-3">Role</th>
            <th class="px-5 py-3 text-center">Stamp Allowed</th>
            <th class="px-5 py-3 text-center w-28">เลือก</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100 dark:divide-slate-800">
          <tr *ngFor="let u of userPickerRows"
            class="hover:bg-amber-50/40 dark:hover:bg-slate-800/60 transition-colors">
            <td class="px-5 py-3 font-semibold text-slate-700 dark:text-slate-200">{{ u.login || '—' }}</td>
            <td class="px-5 py-3 text-slate-600 dark:text-slate-300">{{ u.roleName || '—' }}</td>
            <td class="px-5 py-3 text-center">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold border"
                [ngClass]="u.stampAllowed
                  ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 border-emerald-200 dark:border-emerald-800'
                  : 'bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 border-slate-200 dark:border-slate-700'">
                {{ u.stampAllowed ? 'Yes' : 'No' }}
              </span>
            </td>
            <td class="px-5 py-3 text-center">
              <button type="button" (click)="selectUserFromPicker(u)" [disabled]="isSaving()"
                class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-bold bg-amber-400 hover:bg-amber-500 text-white disabled:opacity-50 transition-colors">
                <span class="material-icons text-[14px]">check</span>
                เลือก
              </button>
            </td>
          </tr>
          <tr *ngIf="!userPickerLoading() && userPickerRows.length === 0">
            <td colspan="4" class="px-5 py-12 text-center text-slate-400">
              <span class="material-icons text-3xl mb-2 block opacity-40">search_off</span>
              ไม่พบ user
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex-none px-6 py-4 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3 bg-white dark:bg-slate-900">
      <span class="text-sm font-medium text-slate-500 dark:text-slate-400">
        แสดง {{ userPickerStartIndex }} - {{ userPickerEndIndex }} จาก {{ userPickerTotal }} รายการ
      </span>
      <div class="flex items-center gap-2">
        <button type="button" (click)="userPickerPrev()" [disabled]="userPickerPage <= 1"
          class="px-4 py-2 rounded-xl text-xs font-bold border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 disabled:opacity-40 transition-colors">
          ก่อนหน้า
        </button>
        <span class="text-xs font-bold text-slate-500 tabular-nums px-1">
          หน้า {{ userPickerPage }} / {{ userPickerTotalPages || 1 }}
        </span>
        <button type="button" (click)="userPickerNext()" [disabled]="userPickerPage >= userPickerTotalPages"
          class="px-4 py-2 rounded-xl text-xs font-bold border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 disabled:opacity-40 transition-colors">
          ถัดไป
        </button>
      </div>
    </div>
  </div>
</div>

<app-pss-confirm-modal *ngIf="showConfirm"
  [title]="confirmTitle"
  [message]="confirmMessage"
  [highlight]="confirmHighlight"
  [messageSuffix]="confirmMessageSuffix"
  [confirmLabel]="confirmLabel"
  [icon]="confirmIcon"
  [variant]="confirmVariant"
  [showIrreversibleNote]="false"
  (confirm)="onConfirmAction()"
  (cancel)="closeConfirm()">
</app-pss-confirm-modal>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && activityHistoryEntityId"
  [entityType]="activityEntityTypes.StampGroup"
  [entityId]="activityHistoryEntityId"
  title="ประวัติกลุ่ม Stamp"
  [subtitle]="'#' + activityHistoryEntityId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
